import { render } from "./YouthContent.vue?vue&type=template&id=3d4e4b76"
import script from "./YouthContent.vue?vue&type=script&lang=js"
export * from "./YouthContent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__